const CLOSE = 'CLOSE'
const REJECT = 'REJECT'
const CONFIRM = 'CONFIRM'
const VERIFY = 'VERIFY'
const RESENDCODE = 'RESEND'
const TO_VERIFY_ONE = 'TO_VERIFY_ONE'
const TO_VERIFY_TWO = 'TO_VERIFY_TWO'

const EMAIL = 'EMAIL'
const SMS = 'SMS'

export const Operations = {
  REJECT,
  CONFIRM,
  VERIFY,
  RESENDCODE,
  CLOSE,
  TO_VERIFY_ONE,
  TO_VERIFY_TWO,
}
export const VerificationMethods = {
  EMAIL,
  SMS,
}
export const SetPhoneOperationBackEndMap = {
  PHONE_SETUP_VERIFY: 'PHONE_SETUP_VERIFY',
  PHONE_SETUP_SKIP: 'PHONE_SETUP_SKIP',
  PHONE_SETUP_SEND: 'PHONE_SETUP_SEND',
  PHONE_SETUP_RESEND: 'PHONE_SETUP_RESEND',
  PHONE_SETUP_BACK: 'PHONE_SETUP_BACK',
}
export const StepModeMap = {
  SETUP_PHONE_STEP_ONE: 'SETUP_PHONE_STEP_ONE',
  SETUP_PHONE_STEP_TWO: 'SETUP_PHONE_STEP_TWO',
  VERIFY_PHONE_STEP_ONE: 'VERIFY_PHONE_STEP_ONE',
  VERIFY_PHONE_STEP_TWO: 'VERIFY_PHONE_STEP_TWO',
  MFA_STEP_ONE_FOR_AUI: 'MFA_STEP_ONE_FOR_AUI',
  MFA_STEP_ONE_FOR_CUI: 'MFA_STEP_ONE_FOR_CUI',
  MFA_STEP_TWO_FOR_AUI: 'MFA_STEP_TWO_FOR_AUI',
  MFA_STEP_TWO_FOR_CUI: 'MFA_STEP_TWO_FOR_CUI',
}
